<style>
.bg-primary {
  background-color: #1a3665 !important;
}
.bg-active {
  background-color: #3e5d92;
}
.bg-subactive {
  background-color: #486ba7;
}
</style>
<template>
    <!-- Data BPK -->
    <CCardBody>
      <CRow>
        <div class="col-sm-12 col-xl-12 ml-auto">
          <div class="form-group">
            <label for>Tahun</label>
            <select name="" class="form-control" id=""  @change="pilihTahun($event)">
              <option value="default">Semua</option>
              <option v-for="(value,index) in dataTahun" :value="value" :key="index">{{ value }}</option>
            </select>
          </div>
        </div>
        <div class="col-sm-12 col-xl-2">
          <div class="form-group">
            <label for>Data Perhalaman</label>
            <select class="form-control" name id @change="changePageSizePengajuanSkp">
              <option>10</option>
              <option>25</option>
              <option>100</option>
              <option>Semua Data</option>
            </select>
        </div>
        </div>
        <div class="col-sm-12 col-xl-3 ml-auto">
          <div class="form-group">
            <label for>Pencarian</label>
            <input type="text" name id class="form-control" v-model="searchPengajuanSkp" placeholder="Cari Data ..." />
          </div>
        </div>
      </CRow>
      <CRow>
        <CCol lg="12" class="table-responsive">
          <CDataTable style="width:125% !important" :items="items" :fields="fields" hover sorter>
            <template #no="{index}">
              <td class="py-2">{{indexed == 0 ? index +1: index+indexed + 1}}</td>
            </template>

            <template #jumlah_skp="{item}">
              <td class="py-2 text-center font-weight-bold">{{ item.jumlah_skp ? item.jumlah_skp : '0'   }} SKP</td>
            </template>
            <template #tahun_pengajuan="{item}">
              <td class="py-2 text-center font-weight-bold" v-if="item.tahun_pengajuan">{{ item.tahun_pengajuan ? item.tahun_pengajuan : '-'   }}</td>
              <td class="py-2 text-center font-weight-bold" v-else>{{ item.tahun ? item.tahun : '-'   }}</td>
            </template>
            <template #skp_diterima="{item}">
              <td class="py-2 text-center font-weight-bold">{{ item.skp_diterima ? item.skp_diterima : '0' }} SKP</td>
            </template>
            <template #tanggal_pengajuan="{item}">
              <td class="py-2">{{ item.tanggal_pengajuan ? item.tanggal_pengajuan : '-' }}</td>
            </template>
           

           <template #status_pengajuan="{item}">
              <td class="py-2 text-center font-weight-bold text-success" v-if="item.status_pengajuan == '1'">
                {{ item.status_pengajuan_label }}
              </td>
              <td class="py-2 text-center font-weight-bold text-danger" v-else-if="item.status_pengajuan == '2'">
                {{ item.status_pengajuan_label }}
              </td>

              <td class="py-2 text-center font-weight-bold text-secondary" v-else>
                {{ item.status_pengajuan_label }}
              </td>
            </template>
            <template #_status="{item}">
              <td class="py-2">
                <button class="btn btn-sm btn-succes" v-if="item._status == 1">Terverifikasi</button>
                <button class="btn btn-sm btn-danger" v-else>Belum Terverifikasi</button>
              </td>
            </template>
            <template #bukti="{item}">
              <td>
                <button @click="bukaFileLogo(item.file_bukti_pengajuan_skp,'bukti')" :class="item.file_bukti_pengajuan_skp == null ? 'btn btn-secondary p-0 px-3 shadow mx-auto' : 'btn btn-sm btn-success p-0 px-3 shadow mx-auto'" :disabled="item.file_bukti_pengajuan_skp == null">
                  {{ "file" }}
                </button>
              </td>
            </template>

            <template #aksi="{item, index}">
              <td class="py-2 d-flex align-items-center text-center">
                
                <CButton v-c-tooltip="'Ubah Status Pengajuan'" color="info" class="btn-sm text-white mr-2" square @click="updateData(item)">
                  <font-awesome-icon icon="edit" />
                </CButton>
                <CButton
                  v-c-tooltip="'Lihat Detail'"
                  color="success"
                  class="btn-sm mr-2"
                  square
                  @click="Detail(item)"
                >
                  <font-awesome-icon icon="eye" />
                </CButton>
                <!-- </router-link> -->
                <CButton v-c-tooltip="'Hapus Data'" color="danger" class="btn-sm" square @click="deleteData(item, index)">
                  <font-awesome-icon icon="trash" />
                </CButton>
              </td>
            </template>
          </CDataTable>
        </CCol>
        <CCol lg="12" class="mt-2">
          <CPagination
            style="float:right"
            :active-page.sync="currentPagePengajuanSkp"
            :pages="pagination.totalPages"
            responsive
            @click="pageChange"
          />
        </CCol>
      </CRow>
      <CModal
        title="Modal title"
        :show.sync="myModal"
        :no-close-on-backdrop="true"
        :centered="true"
      >
        <CForm>
          <CRow>
            <CCol sm="12">
              <div class="form-group">
                <label for="" class="font-weight-bold">Status Pengajuan</label>
                <select name="" class="form-control" id="" v-model="formData.status_pengajuan" >
                  <option value="" disabled selected>Pilih Status Pengajuan</option>
                  <option value="1">Disetujui</option>
                  <option value="2">Tidak Disetujui</option>
                </select>
              </div>
              <div class="form-group" >
                <label for="" class="font-weight-bold">SKP Di Ajukan</label>
                <TextField
                  myclass="form-control"
                  id="id_skp_diajukan"
                  placeholder="Masukkan Skp Di Ajukan" 
                  readonly                  
                  :required="true" 
                  characterAllow="1234567890"
                  v-model="formData.skp_diajukan" 
                />
              </div>
              <div class="form-group" v-show="formData.status_pengajuan == '1'">
                <label for="" class="font-weight-bold">SKP Diterima</label>
                <TextField
                  myclass="form-control"
                  id="id_skp_diterima"
                  placeholder="Masukkan SKP Diterima" 
                  value="0"
                  min="1"
                  :max="formData.skp_diajukan"
                  v-model="formData.skp_diterima"
                  :class="{
                      'is-invalid': $v.formData.skp_diterima.$error || formData.skp_diterima == 0 && formData.skp_diterima > formData.skp_diajukan 
                    }"
                />
                <span class="text-danger" v-if="$v.formData.skp_diterima.$model < 1">
                  *SKP yang diterima tidak boleh 0
                </span>
                <span class="text-danger" v-if="$v.formData.skp_diterima.$model > parseInt(formData.skp_diajukan)">
                  *SKP yang diterima tidak boleh lebih dari {{formData.skp_diajukan}}
                </span>
                
              </div>
              <div class="form-group" v-show="formData.status_pengajuan == '1'">
                <label for="" class="font-weight-bold">Katalog</label>
                 <select name="" v-model="formData.id_katalog" id="" class="form-control">
                   <option v-for="(value, index) in optionKodePelatihan" :value="value.idKodePelatihan" :key="index">{{ value.kodePelatihan }}</option>
                 </select>
              </div>
              <div class="form-group" v-show="formData.status_pengajuan == '2'">
                <label for="" class="font-weight-bold">Keterangan</label>
                <textarea cols="30" rows="10" class="form-control" v-model="formData.keterangan"></textarea>
              </div>
            </CCol>
          </CRow>
        </CForm>
        <template #header>
          <h6 class="modal-title h4 font-weight-bold">Konfirmasi Pengajuan SKP</h6>
        </template>
        <template #footer class="mt-5">
          <CButton @click="myModal = false" color="danger">Tutup</CButton>
          <CButton @click="postStatus" type="submit" color="success">Simpan</CButton>
        </template>
      </CModal>

      <CModal
      title="Modal title"
      :show.sync="modalDetail"
      :no-close-on-backdrop="true"
      :centered="true"
      size="lg"
      >
        <CRow>
          <div class="modal-body row my-n3">
            <table class="table">
              <tr>
                <th style="width: 40%">No Anggota</th>
                <td>:</td>
                <td>{{ detailData.no_anggota ? detailData.no_anggota : '-' }}</td>
              </tr>
              <tr>
                <th>Kategori Anggota</th>
                <td>:</td>
                <td>{{ detailData.nama_kategori ? detailData.nama_kategori : '-' }}</td>
              </tr>
              <tr>
                <th>Nama Anggota</th>
                <td>:</td>
                <td>{{ detailData.nama_lengkap ? detailData.nama_lengkap : '-' }}</td>
              </tr>
              <tr>
                <th>Email</th>
                <td>:</td>
                <td>{{ detailData.email ? detailData.email : '-' }}</td>
              </tr>
              <tr>
                <th>No. Handphone</th>
                <td>:</td>
                <td>{{ detailData.no_handphone ? detailData.no_handphone : '-' }}</td>
              </tr>
              <tr>
                <th>No. Telepon</th>
                <td>:</td>
                <td>{{ detailData.no_telephone ? detailData.no_telephone : '-' }}</td>
              </tr>
              <tr>
                <th>Nama Pelatihan</th>
                <td>:</td>
                <td>{{ detailData.nama_pelatihan ? detailData.nama_pelatihan : '-' }}</td>
              </tr>
              <tr>
                <th>Nama Penyelenggara</th>
                <td>:</td>
                <td>{{ detailData.nama_penyelenggara ? detailData.nama_penyelenggara : '-' }}</td>
              </tr>
              <tr>
                <th>Tanggal Pengajuan</th>
                <td>:</td>
                <td>{{ detailData.tanggal_pengajuan ? detailData.tanggal_pengajuan : '-' }}</td>
              </tr>
              <tr>
                <th>Tanggal Pelatihan</th>
                <td>:</td>
                <td>{{ detailData.tanggal_mulai + " - "+ detailData.tanggal_berakhir }}</td>
              </tr>
              <tr>
                <th>Jumlah SKP</th>
                <td>:</td>
                <td>{{ detailData.jumlah_skp ? detailData.jumlah_skp : '0' }}</td>
              </tr>
              <tr>
                <th>Durasi Pelatihan</th>
                <td>:</td>
                <td>{{ detailData.durasi ? detailData.durasi : '0' }} Menit</td>
              </tr>
            </table>
          </div>
        </CRow>
        <template #header>
          <h6 class="modal-title h5 font-weight-bold">Detail Pengajuan SKP</h6>
        </template>
        <template #footer>
          
          <CButton @click="modalDetail = false" color="danger">Tutup</CButton>
        </template>
      </CModal>
    </CCardBody>
    <!-- End Data BPK -->
</template>
<script>
/**
 * @Service
 */
import PengajuanSkpPesertaService from "@/services/pelatihan/pengajuan-skp-peserta/pengajuan-skp-peserta.service";
import Utils from "@/services/utils.service";

import { required, minLength, requiredIf, minValue } from 'vuelidate/lib/validators'

/**
 * @Mixins
 */
import { AlertUtils } from "@/mixins/AlertUtils";
import { Pagination } from "@/mixins/Pagination";
import { KodePelatihan } from "@/mixins/master/KodePelatihan"
import { exportUtils } from '@/mixins/exportUtils';


/**
 * @Component
 */
import TextField from "@/components/formcomponent/TextField"

import { bus } from '../../../../src/main'

const fields = [
  {
    key: "no",
    label: "No",
    sorter: true,
    filter: false
  },
  {
    key: "nama_lengkap",
    label: "Nama Peserta",
    sorter: true,
    filter: false,
    stickyColumn: true
  },
  {
    key: "nama_pelatihan",
    label: "Nama Pelatihan",
    sorter: true,
    filter: false
  },
 
  {
    key: "tanggal_pengajuan",
    label: "Tanggal Pengajuan",
    sorter: true,
    filter: false
  },
  {
    key: "tahun_pengajuan",
    label: "Tahun",
    sorter: true,
    filter: false
  },
  {
    key: "jumlah_skp",
    label: "SKP Diajukan",
    sorter: true,
    filter: false
  },
  {
    key: "skp_diterima",
    label: "SKP Disetujui",
    sorter: true,
    filter: false
  },
  {
    key: "status_pengajuan",
    label: "Status",
    sorter: true,
    filter: false
  },
  {
    key: "bukti",
    label: "Bukti",
    sorter: true,
    filter: false
  },
  {
    key: "aksi",
    _style: "width: 10%; text-align: center",
    sorter: false,
    filter: false
  }
];

export default {
  mixins: [AlertUtils, Pagination,KodePelatihan,exportUtils],
  name: "Data Peserta",
  components : {
    TextField
  },
  data() {
    return {
      items: [],
      formData: {
        id_pengajuan_skp: "",
        status_pengajuan: "1",
        jenis_pengajuan: "",
        skp_diajukan : "" ,
        skp_diterima : "",
        id_katalog : "",
        keterangan : ""
      },
      modalDetail : false,
      fields,
      details: [],
      detailData : {},
      no: 1,
      status: false,
      myModal: false,
      horizontal: { label: "col-3", input: "col-9" },
      collapseDuration: 0,
      content: [],
      dataTahun: [],
    };
  },
  validations: {
    formData: {
      skp_diterima: { 
        required : requiredIf(function() {
          return this.formData.status_pengajuan == '1'
        })
      },
    },
  },
  beforeDestroy () {
  
  },
  mounted() {
    this.getAllKodePelatihan();
    this.getData(
      "0",
      this.pageSize,
      this.filter,
      'default'
    )
    for (let index = 0; index < 30; index++) {
      this.dataTahun.push(2020+index)
    }
  },
  created() {
    var vm = this;
    bus.$off('exportPengajuanChild2')
    bus.$on('exportPengajuanChild2', (data) => {
      vm.exportPengajuan(data,vm.tahun)
    })

  },
  methods: {
    exportPengajuan(jenis,tahun) {
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel,
      });
      PengajuanSkpPesertaService.exportPengajuanSkp(jenis,tahun)
      .then(response => {
        loader.hide()
        this.exportData(response.data, 'Data Pengajuan Terstruktur SKP')
        this.alertExportSuccess(); 
      }).catch(error => {
        loader.hide()
        this.alertExportFailed();
      })
    },
    pilihTahun(e) {
      this.getData(
        "0",
        this.pageSize,
        this.searchPengajuanSkp,
        e.target.value
      )
    },
    pageChange() {
      this.getData(currentPagePengajuanSkp, this.pageSize, this.filter)
    },
    Detail(item) {
      this.modalDetail = true;
      this.detailData = item
    },
    updateData(item) {
      this.myModal = true
      this.formData.id_pengajuan_skp = item.id_pengajuan_skp
      this.formData.status_pengajuan = item.status_pengajuan
      this.formData.jenis_pengajuan = item.jenis_pengajuan
      this.formData.skp_diajukan = item.skp_diajukan
      this.formData.skp_diterima = item.skp_diterima
      this.formData.id_katalog = item.id_katalog
       
      if(item.status_pengajuan == '0') {
        this.formData.status_pengajuan = ''
      } else {
        this.formData.status_pengajuan = item.status_pengajuan
      }
      this.formData.keterangan = item.keterangan
    },

    postStatus() {
      this.$v.$touch();           
      if(this.formData.status_pengajuan == '') {
        this.alertError("Status Pengajuan Harus Dipilih")
        return false
      }

      if(this.$v.formData.skp_diterima.$error) {
        return false
      } else {
        this.insertDataStatus()
      }
    },

    insertDataStatus() {      
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel
      });
      PengajuanSkpPesertaService.putDataPengajuan(this.formData)
      .then(response => {
        this.getData(
          "0",
          this.pageSize,
          this.searchPengajuanSkp,
          this.tahun
        )
        this.myModal = false
        loader.hide()
        this.alertSuccess();
      }).catch(error => {
        loader.hide()
        this.alertError(error.response.data.message)
      })

    },
    bukaFileLogo (file) {

      let user = JSON.parse(localStorage.getItem('user'));
      let token = user.accessToken
      let params = `scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no,width=0,height=0,left=-1000,top=-1000`;
      window.open(
        Utils.baseurlFoUsers() + "/lihat-file/"+file+"/lokasi/bukti_pengajuan_skp/bearer/" + token,
        file,
        params
      );
    },

    deleteData(item, index) {
      this.$swal
        .fire({
          title: "Peringatan!",
          text: "Apakah anda yakin ingin menghapus data ini?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Ya",
          cancelButtonText: "Tidak",
          confirmButtonColor: "#d33",
          cancelButtonColor: "#3085d6",
          reverseButtons: true
        })
        .then(result => {
          if (result.value) {
            let loader = this.$loading.show({
              container: false ? null : this.$refs.formContainer,
              canCancel: true,
              onCancel: this.onCancel
            });
            var form = {
              id_pengajuan_skp : item.id_pengajuan_skp
            }
            PengajuanSkpPesertaService.deleteDataPengajuan(form)
            .then(response => {
              loader.hide()
              this.getData(
                "0",
                this.pageSize,
                this.searchPengajuanSkp,
                this.tahun
              )
              this.alertDeleteSuccess()
            }).catch(error => {
              loader.hide()
              this.alertError("Data gagal di hapus")
            })
          } else if (result.dismiss === Swal.DismissReason.cancel) {
            
          }
        });
    },

    getData(currentPagePengajuanSkp, pageSize, filter,tahun) {
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel
      });

      var vm = this;
      vm.tahun = tahun
      
      PengajuanSkpPesertaService.getDataPengajuanTidakTerstrukturKeStruktur(
        currentPagePengajuanSkp,
        pageSize,
        filter,
        tahun
      )
        .then(response => {
          loader.hide();
          vm.items = response.data.data.content;
          vm.pagination.totalPages = response.data.data.totalPages;
          vm.currentPagePengajuanSkp = response.data.data.pageable.pageNumber + 1;
        })
        .catch(error => {
          // comment console console.log(error);
          loader.hide();
        });
    },
  }
};
</script>